import React from "react";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";

const ItemCommentsView = ({ value }: { value: string }) => {
  const { theme, t, typography } = useScreenOptionsHooks();

  return (
    <SectionContainer>
      <Row>
        <Label>
          <VDBText color={theme["core-06"]} type={typography["Minor-R"]}>
            {t("orderCart.itemCard.comments.text", "Comments")}:
          </VDBText>
        </Label>
        <Spacer size={SpaceType.Basic} />
        <Value>
          <VDBText color={theme["core-05"]} type={typography["Minor-M"]}>
            {value}
          </VDBText>
        </Value>
      </Row>
    </SectionContainer>
  );
};

export default ItemCommentsView;

const SectionContainer = styled.View`
  padding: ${SpaceType.Basic}px;
  background-color: ${({ theme }) => theme["core-01"]};
`;

const Row = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;

const Label = styled.View`
  width: 155px;
`;

const Value = styled.View`
  flex: 1;
`;
